import { store } from '@/state/store.js';
import { handleErrors } from '@/utils/errors.js';
import { devRoutes } from '@/routes/routes-dev.js';
import { orgRoutes } from '@/routes/routes-org.js';
import { AuthApi } from '@/services/api-auth.js';
import { router } from '@/routes/index.js';

export const routes = [
  // Signup
  {
    path: '/join',
    name: 'join',
    component: () => import(/* webpackChunkName: "signup" */ '@/views/auth/join.vue'),
    props: { disableTracking: true },
    meta: {
      disableTracking: true,
      // Check if already logged in
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['me/isLoggedIn']) {
          router.replace({ name: 'teams.index' });
          return;
        }
        next();
      },
    },
  },

  // Verification Tokens
  {
    path: '/t/:token',
    name: 'token.index',
    component: () => import(/* webpackChunkName: "signup" */ '@/views/auth/token.vue'),
    props: true,
    meta: {
      disableTracking: true,
      beforeResolve(routeTo, routeFrom, next) {
        AuthApi.createEmailVerification(routeTo.params.token)
          .then((response) => {
            routeTo.params.verification = response;
            next();
          })
          .catch((err) => {
            if (err.response && err.response.status === 403) {
              routeTo.params.message = err.response.data.error;
              next();
              return;
            }

            handleErrors(err, next, 'Email Verification');
          });
      },
    },
  },

  // Auth User Account
  {
    path: '/account',
    name: 'account.show',
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/show.vue'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        store
          .dispatch('me/getUser')
          .then(() => {
            next();
          })
          .catch((err) => {
            handleErrors(err, next, 'Account Profile');
          });
      },
    },
  },

  // Teams
  {
    path: '/teams',
    name: 'teams.index',
    component: () => import(/* webpackChunkName: "teams" */ '@/views/teams/index.vue'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        store
          .dispatch('teams/index', false)
          .then(() => {
            next();
          })
          .catch((err) => {
            handleErrors(err, next, 'Teams');
          });
      },
    },
    children: [
      {
        path: ':teamType/create',
        name: 'teams.create',
        component: () => import(/* webpackChunkName: "teams" */ '@/views/teams/create.vue'),
        props: true,
      },
    ],
  },

  // SUPPORT //
  {
    path: '/support',
    name: 'support.index',
    component: () => import(/* webpackChunkName: "support" */ '@/views/support/Index.vue'),
  },

  ...devRoutes,
  ...orgRoutes,

  // Catch-all
  {
    // path: "*",
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "errors" */ '@/views/errors/404.vue'),
    beforeEnter(to, from, next) {
      // fake out an http error response
      let err = new Error('Page Not Found');
      err.response = { status: 404 };
      handleErrors(err, next, 'Page');
    },
  },
];
